import axios from 'axios'
import env from "react-dotenv";
import api from '../axios';

export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_ALL_UNAPPROVED_USERS = 'GET_ALL_UNAPPROVED_USERS'
export const APPROVE_USER = 'APPROVE_USER'

export const ADD_USER = 'ADD_USER'
export const EDIT_USER = 'EDIT_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const DELETE_USER = 'DELETE_USER'
export const GET_ALL_USER_ACTIVITY = 'GET_ALL_USER_ACTIVITY'
export const GET_USER_ACTIVITY = 'GET_USER_ACTIVITY'
export const DELETE_USER_ACTIVITY = 'DELETE_USER_ACTIVITY'
export const GET_ANALYTICS_USERACTIVITY = 'GET_ANALYTICS_USERACTIVITY'


export const SAVE_FORMDATA = 'SAVE_FORMDATA'
export const CLEAR_FORMDATA = 'CLEAR_FORMDATA'
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT'


export const saveFormData = (payload) => (dispatch) => {
    dispatch({ type: SAVE_FORMDATA, payload})
}

export const clearFormData = () => (dispatch) => {
    dispatch({ type: CLEAR_FORMDATA})
}

export const registerParticipant = (payload) => (dispatch) => {
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }
    return api.post('/participants', payload, apiHeader)
        .then(response => {
            dispatch({ type: ADD_PARTICIPANT, payload: response.data})
            return Promise.resolve(response)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
